import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsInventoryLazy = loadable(
    () => import(/* webpackChunkName: "SettingsInventory" */ './SettingsInventorySuspense')
);

export const SettingsInventoryAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsInventoryLazy />
    </DelayedSuspense>
);
